import { render, staticRenderFns } from "./RegistrationDataPolicyForm.vue?vue&type=template&id=fe8ac890&scoped=true&"
import script from "./RegistrationDataPolicyForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationDataPolicyForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDataPolicyForm.vue?vue&type=style&index=0&id=fe8ac890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8ac890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VForm,VRow})
